import React, { useContext, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import useAIChatBot from '@/modules/AiAgents/components/Agents/Nugz/logic';
import { AIContext } from '@/modules/AiAgents/context/nugzContext/context';
import { IAI } from '@/modules/AiAgents/types';
import { Table } from '@/shared/components/atoms';

const AIFieldsTable = () => {
  const {
    state: { tableList, isEditing },
  } = useContext(AIContext);
  const { getFieldsTableColumn } = useAIChatBot();
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<IAI.IFieldsFormSchema>();

  // Map tableList to include error states in UI only

  const tableData = useMemo(() => {
    return tableList.map((field) => ({
      ...field,
      error: field.hasSessionDuplicate || field.hasExistingDuplicate,
    }));
  }, [tableList]);

  const columns = useMemo(
    () => getFieldsTableColumn(isEditing, control, register, errors),
    [isEditing, control, register, errors, getFieldsTableColumn]
  );
  // console.log(tableData)

  return (
    <Table<IAI.IAIFieldProps & { error?: boolean }>
      data={tableData}
      columns={columns}
      selection={false}
      pagination={false}
      headCellClassName='text-start border-b-xs border-neutralVariant-90 text-surface-10'
      headContainerClassName='!bg-background-neutral-99 !text-12'
      rowContainerClassName='!bg-background-transparent last-of-type:border-b-0 border-neutralVariant-90 border-b-xs'
      tableWrapperClassName='max-h-[55vh]'
      tableClassName='!border-collapse'
      headerClassName='!z-[1]'
    />
  );
};

export { AIFieldsTable };
